export default "__VITE_ASSET__DdGxjMWv__"